import React, { useRef } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import backgroundDesktopImage from "../../assets/images/home/velo_same_2x.webp";
import bannerMobileImage from "../../assets/images/home/velo_same_mobile_2x.webp";

import backgroundDesktopImage2 from "../../assets/images/home/skruf_web_2x.webp";
import bannerMobileImage2 from "../../assets/images/home/skruf_mob_2x.webp";

import backgroundDesktopImage3 from "../../assets/images/home/skruf_zyn_cuba_desktop.webp";
import bannerMobileImage3 from "../../assets/images/home/skruf_zyn_cuba_mob.webp";

const Container = styled.div`
  overflow: hidden;

  width: 100%;
  height: 60vh;
  @media (min-width: 768px) {
    text-align: left;
  }
`;
const SlideWrapper = styled.div`
  width: 100%;

  color: #000;
  font-size: 1.5rem;
  font-weight: bold;
  height: 60vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  background-image: url(${(props) => props.$mobileimage});

  @media (min-width: 768px) {
    background-image: url(${(props) => props.$desktopimage});
    background-position: center;
  }

  position: relative;
`;
const SliderInner = styled.div`
  position: absolute;
  top: 50%;
  width: 80%;
  left: 10%;
  color: var(--text-100);
  padding: 10px;
  font-size: var(--font-size-base);

  @media (max-width: 768px) {
    height: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  @media (min-width: 768px) {
    top: 30%;
    width: 40%;
    left: 200px;
    font-size: var(--font-size-large);
  }
`;
const SliderText = styled.span`
  background-color: #ffffff80;
`;
const SliderButton = styled.button`
  margin-top: 14px;
  width: 100%;
  text-transform: uppercase;
  @media (min-width: 768px) {
    width: auto;
  }
`;

const ArrowButton = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  top: 30%;
  transform: translateY(-50%);
  color: ${(props) => (props.disabled ? "var(--bg-300)" : "#00000033")};

  @media (min-width: 768px) {
    top: 50%;
  }
`;

const NextArrow = ({ onClick, currentSlide, slideCount }) => {
  const { t } = useTranslation();
  const isDisabled = currentSlide >= slideCount - 1;
  return (
    <ArrowButton
      style={{ right: "7%" }}
      onClick={isDisabled ? null : onClick}
      disabled={isDisabled}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-label={t("ARIA.NEXT_IMAGE")}
      aria-disabled={isDisabled}
      onKeyDown={(e) => {
        if (!isDisabled && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick && onClick(e);
        }
      }}
    >
      <svg
        width="60px"
        height="60px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 15L16 12M16 12L13 9M16 12H8M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          stroke={!isDisabled ? "var(--bg-100)" : "#00000033"}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="#00000033"
        />
      </svg>
    </ArrowButton>
  );
};

const PrevArrow = ({ onClick, currentSlide }) => {
  const { t } = useTranslation();
  const isDisabled = currentSlide === 0;
  return (
    <ArrowButton
      style={{ left: "7%" }}
      onClick={isDisabled ? null : onClick}
      disabled={isDisabled}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-label={t("ARIA.PREVIOUS_IMAGE")}
      aria-disabled={isDisabled}
      onKeyDown={(e) => {
        if (!isDisabled && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick && onClick(e);
        }
      }}
    >
      <svg
        width="60px"
        height="60px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 9L8 12M8 12L11 15M8 12H16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          stroke={!isDisabled ? "var(--bg-100)" : "#00000033"}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="#00000033"
        />
      </svg>
    </ArrowButton>
  );
};

const HomeHero = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1, // Default number of slides to show
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Container className="header-top-margin">
      <Slider {...settings} ref={sliderRef}>
        <SlideWrapper
          $mobileimage={bannerMobileImage}
          $desktopimage={backgroundDesktopImage}
        >
          <SliderInner>
            <SliderText>
              Discover VELO, the perfect blend of innovation and quality.
              Designed for those who seek a refreshing and discreet way to enjoy
              nicotine, VELO offers a wide variety of flavors and strengths to
              suit every preference.
            </SliderText>
            <SliderButton>Explore more</SliderButton>
          </SliderInner>
        </SlideWrapper>
        <SlideWrapper
          $mobileimage={bannerMobileImage2}
          $desktopimage={backgroundDesktopImage2}
        >
          <SliderInner>
            <SliderText>
              Skruf stands for premium quality and authentic flavor. Crafted for
              connoisseurs of fine nicotine pouches, Skruf delivers a refined
              experience in every pouch.
            </SliderText>
            <SliderButton>Explore more</SliderButton>
          </SliderInner>
        </SlideWrapper>
        <SlideWrapper
          $mobileimage={bannerMobileImage3}
          $desktopimage={backgroundDesktopImage3}
        >
          <SliderInner>
            <SliderText>
              Explore the leading names in nicotine pouches: Skruf, ZYN, and
              Cuba. Each brand offers a unique range of flavors and strengths,
              ensuring there’s something for everyone.
            </SliderText>
            <SliderButton>Explore more</SliderButton>
          </SliderInner>
        </SlideWrapper>
      </Slider>
    </Container>
  );
};

export default HomeHero;
